var render = function () {
  var _vm$currentRound$cont, _vm$currentRound$cont2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("stop-drop-and-type " + (_vm.keyboardEnabled ? '' : 'full-height')),
      "customContentContainerStyles": {
        height: _vm.keyboardEnabled ? 'calc(100% - 45px)' : '100%'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('figure', {
    staticClass: "focusable",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('figcaption', [_c('b', {
    domProps: {
      "textContent": _vm._s(_vm.currentRound.title)
    }
  })]), _c('img', {
    attrs: {
      "alt": (_vm$currentRound$cont = _vm.currentRound.contentImage) === null || _vm$currentRound$cont === void 0 ? void 0 : _vm$currentRound$cont.image.description,
      "src": (_vm$currentRound$cont2 = _vm.currentRound.contentImage) === null || _vm$currentRound$cont2 === void 0 ? void 0 : _vm$currentRound$cont2.image.src
    }
  }), _vm._l(_vm.currentRound.text, function (text) {
    return _c('figcaption', {
      key: text,
      staticClass: "text",
      domProps: {
        "textContent": _vm._s(text)
      }
    });
  })], 2), _c('div', {
    staticClass: "steps",
    class: {
      isMobileView: _vm.isMobile
    }
  }, [_c('div', {
    attrs: {
      "id": "sdtInstructions"
    }
  }, [_c('audio-toggle-button'), _c('h1', [_c('b', {
    domProps: {
      "textContent": _vm._s(_vm.customInstructions)
    }
  })])], 1), _vm._l(_vm.currentRound.steps, function (step) {
    return _c('text-display-dropdown', {
      key: ("dropdown-" + (step.id)),
      attrs: {
        "options": step.answers,
        "show-options": _vm.showOptions,
        "dropdown-id": ("dd-" + (step.id)),
        "selected-correct": _vm.handleCorrectSelect,
        "selected-incorrect": _vm.handleIncorrectSelect,
        "label": step.question,
        "step-index": step.stepIndex,
        "completed": _vm.completedIndexes.includes(step.stepIndex) ? true : false,
        "disable-drop-down": _vm.progress.stepIndex !== step.stepIndex ? _vm.disableDropDown : false
      }
    });
  })], 2)])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }